import React from 'react';
import UpdateChecker from '../../components/UpdateChecker';

const Updates = () => {
  return <UpdateChecker />;
};

export default Updates;